import { render, staticRenderFns } from "./ContactHero.vue?vue&type=template&id=1c825a2f&scoped=true"
var script = {}
import style0 from "./ContactHero.vue?vue&type=style&index=0&id=1c825a2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c825a2f",
  null
  
)

export default component.exports